import React from 'react';
import { HiCheckCircle, HiXCircle, HiExclamationCircle, HiInformationCircle, HiX } from 'react-icons/hi';
import { SNACKBAR_TYPES } from '../../contexts/SnackbarContext';

const getIconAndStyles = (type) => {
    switch (type) {
        case SNACKBAR_TYPES.SUCCESS:
            return {
                icon: <HiCheckCircle className="h-5 w-5 text-green-400" />,
                bgColor: 'bg-green-50',
                borderColor: 'border-green-400',
                textColor: 'text-green-800'
            };
        case SNACKBAR_TYPES.ERROR:
            return {
                icon: <HiXCircle className="h-5 w-5 text-red-400" />,
                bgColor: 'bg-red-50',
                borderColor: 'border-red-400',
                textColor: 'text-red-800'
            };
        case SNACKBAR_TYPES.WARNING:
            return {
                icon: <HiExclamationCircle className="h-5 w-5 text-yellow-400" />,
                bgColor: 'bg-yellow-50',
                borderColor: 'border-yellow-400',
                textColor: 'text-yellow-800'
            };
        case SNACKBAR_TYPES.INFO:
        default:
            return {
                icon: <HiInformationCircle className="h-5 w-5 text-blue-400" />,
                bgColor: 'bg-blue-50',
                borderColor: 'border-blue-400',
                textColor: 'text-blue-800'
            };
    }
};

const Snackbar = ({ id, message, type = SNACKBAR_TYPES.INFO, onDismiss }) => {
    const { icon, bgColor, borderColor, textColor } = getIconAndStyles(type);

    return (
        <div
            className={`flex items-center p-4 mb-3 rounded-md shadow-md border-l-4 ${bgColor} border-${borderColor} animate-slide-in-right`}
            role="alert"
        >
            <div className="flex-shrink-0 mr-3">
                {icon}
            </div>
            <div className={`flex-1 ${textColor}`}>
                {message}
            </div>
            <button
                type="button"
                className="ml-auto -mx-1.5 -my-1.5 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 inline-flex h-8 w-8 hover:bg-gray-200 hover:bg-opacity-25"
                onClick={() => onDismiss(id)}
                aria-label="Close"
            >
                <HiX className="w-5 h-5" />
            </button>
        </div>
    );
};

export default Snackbar; 